import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios, { CancelToken } from "axios";
import { useHistory } from "react-router-dom";

import { StatusCode } from "api/protocols";

import { TProductType } from "redux/reducers/models/product";
import { useTranslation } from "react-i18next";
import Page from "components/page/Page";
import DataTable from "../../../../../components/dataTable/DataTable";
import { GetProductTypes } from "api/rpc/2024-04/facilityAdmin/product/type";
import { Badge } from "components/badge/Badge";
import { productTypeGroups } from "helpers/Helpers";

export default function ProductTypes() {
  const history = useHistory();
  const { t } = useTranslation();
  const [productTypes, setProductTypes] = useState<TProductType[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadProductTypes(source.token);
    return () => source.cancel();
  }, []);

  async function loadProductTypes(token?: CancelToken) {
    if (productTypes !== undefined) {
      setProductTypes(undefined);
    }

    const res = await GetProductTypes(null, token ? false : true, token);

    if (res.status !== StatusCode.OK) {
      setProductTypes([]);
      return;
    }

    setProductTypes(res.data);
  }

  return (
    <Page
      title={t("Product Types")}
      primaryAction={{
        content: t("Add Type"),
        action: () => history.push("/admin/settings/types/new"),
        disabled: productTypes === undefined,
      }}
    >
      <DataTable
        columns={[
          { label: t("Type"), width: "50%" },
          { label: t("Group"), width: "50%" },
          { label: "" },
        ]}
        loading={productTypes === undefined}
      >
        {productTypes?.map(type => {
          const group = type?.group ? productTypeGroups(t)?.find(group => group?.id === type?.group) : null; 
          return (
            <tr
              key={type.id}
              className={type?.locked ? "" : "clickable"}
              onClick={type?.locked ? null : () => history.push(`/admin/settings/types/${type.id}`)}
            >
              <td>{type.title}</td>
              <td>{group ? <Badge type="gray" size="medium">{group?.label}</Badge> : null}</td>
              <td>{type.locked && <FontAwesomeIcon icon={["far", "cancel"]} />}</td>
            </tr>
          );
        })}
      </DataTable>
    </Page>
  );
}
